import AuthService from './AuthService'
import AutocompleteService from './AutocompleteService'
import { DashboardService } from './Home'
import { InvoicesService } from './InvoicesService'
import { ShipmentsService } from './ShipmentsService'
import MessageService from './MessageService'
import { PushNotificationService } from './PushNotification'
import { ReleasesService } from './ReleasesService'
import { DocumentsService } from './DocumentsService'
import ReportsService from './ReportsService'
import { ShippingDocumentService } from './ShippingDocumentService'

export const $api = {
  auth: AuthService,
  releases: ReleasesService,
  documents: DocumentsService,
  reports: ReportsService,
  invoices: InvoicesService,
  autocomplete: AutocompleteService,
  message: MessageService,
  dashboard: DashboardService,
  shipping: ShippingDocumentService,
  shipments: ShipmentsService,
  notifications: PushNotificationService
}

const ApiPlugin = {
  install (Vue) {
    Vue.prototype.$api = $api
  }
}

export default ApiPlugin
